import * as types from "../Action/type";
import cookie from "react-cookies";
import { act } from "react-dom/test-utils";

// let temp = cookie.load("My-TicketLang");
let temp = sessionStorage.getItem("My-TicketLang");

const initialState = {
  user: null,
  Type: null,
  token: "",
  submit: false,
  language: temp ? JSON.parse(temp) : "ar",
};

const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_UPDATE_USER:
      return {
        ...state,
        user: action.payload,
      };
    case types.FETCH_LOGIN_REQUEST:
      return { ...state, submit: !state.submit };
    case types.FETCH_LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        language: action.payload.user.language,
        Type: action.payload.user.type,
        Rules: action.payload.user.rules,
        submit: !state.submit,
      };
    case types.FETCH_LOGIN_FAIL:
      return { ...state, submit: !state.submit };
    case types.FETCH_LANGUAGE_SUCCESS:
      return { ...state, language: action.payload };
    case types.FETCH_LOGOUT_REQUEST:
      return {
        ...state,
        user: null,
        token: null,
        submit: true,
        userRoles: null,
      };
    case types.FETCH_EDIT_SUCCESS:
      return {
        ...state,
        user: action.payload,
        language: action.payload.language,
        Type: action.payload.type,
        Rules: action.payload.rules,
        submit: !state.submit,
      };
    case types.REINTIALIZE:
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        language: action.payload.lang,
        Type: action.payload.user.type,
      };
    default:
      return state;
  }
};
export default UserReducer;
